/* LCDF mural lifecycle. Functional project state is separate from consent-gated analytics. */
(function (global) {
  'use strict';
  var VERSION = '2026-09-12-photo-first';
  var adapter, active, savedProject, cropCache, pendingCart = false, generationLocked = false;
  var pendingReturn = takeReturnFragment(), previewReturned = false, previewReturnInvalid = false;
  var seen = new Set();
  var translationSource, translationDictionary = Object.create(null);
  function T(text, params) {
    var source = '';
    try {
      var node = global.document && global.document.getElementById('ema-mural-i18n');
      source = node && node.textContent || '';
      if (source !== translationSource) {
        translationSource = source; translationDictionary = Object.create(null);
        // Native locale snippets emit an object; older fixtures encode a dictionary string.
        var encoded = JSON.parse(source);
        var parsed = typeof encoded === 'string' ? JSON.parse(encoded) : encoded;
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) translationDictionary = parsed;
      }
    } catch (_) { translationDictionary = Object.create(null); }
    var translated = Object.prototype.hasOwnProperty.call(translationDictionary, text) &&
      typeof translationDictionary[text] === 'string' && translationDictionary[text] ? translationDictionary[text] : text;
    return String(translated).replace(/\{([A-Za-z0-9_]+)\}/g, function (token, key) {
      return params && Object.prototype.hasOwnProperty.call(params, key) && params[key] !== undefined && params[key] !== null ?
        String(params[key]) : token;
    });
  }
  global.EMAMuralTranslate = T;
  function uuid() {
    return global.crypto && global.crypto.randomUUID ? global.crypto.randomUUID() :
      'ema-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function consent() {
    var privacy = global.Shopify && global.Shopify.customerPrivacy;
    function allowed(method) { try { return !!privacy && privacy[method]() === true; } catch (_) { return false; } }
    function vendor(key) {
      if (!global.Shopify || global.Shopify.shop !== '07a943-df.myshopify.com') return true;
      try { return !!global.EMALcdfConsent && global.EMALcdfConsent.allows(key) === true; } catch (_) { return false; }
    }
    return { analytics: allowed('analyticsProcessingAllowed') && vendor('analytics'), marketing: allowed('marketingAllowed') && vendor('ads'),
      preferences: allowed('preferencesProcessingAllowed') };
  }
  function emit(event, extra, onceKey) {
    if (!consent().analytics || (onceKey && seen.has(onceKey))) return false;
    var data = { event_id: uuid(), is_mural: true, lifecycle_version: VERSION,
      locale: (global.document && document.documentElement.lang) || 'en' };
    var visualization = extra && extra.configuration_type === 'visualization';
    var config = visualization ? (active && active.visualization && active.visualization.configuration) : active && active.configuration;
    if (active) data.project_id = active.project_id;
    if (config) ['configuration_id', 'product_id', 'variant_id', 'width_cm', 'height_cm',
      'paper_name', 'quote_value', 'currency'].forEach(function (key) { data[key] = config[key]; });
    // An explicit allowlist prevents identity, signed URLs or arbitrary error strings leaking.
    ['stage', 'error_code', 'configuration_id', 'product_id', 'variant_id', 'width_cm',
      'height_cm', 'paper_name', 'quote_value', 'currency', 'configuration_type', 'visualization_mode'].forEach(function (key) {
      if (extra && extra[key] !== undefined) data[key] = extra[key];
    });
    if (visualization) {
      ['variant_id', 'paper_name', 'quote_value', 'currency'].forEach(function (key) { delete data[key]; });
      if (data.visualization_mode !== 'selected_crop') { delete data.width_cm; delete data.height_cm; }
    }
    global.dataLayer = global.dataLayer || [];
    // GTM v2 data-layer variables recursively merge objects. Clear the prior
    // payload so a later success cannot inherit an earlier error/stage.
    global.dataLayer.push({ mural: null });
    global.dataLayer.push({ event: event, mural: data });
    if (onceKey) seen.add(onceKey);
    return true;
  }
  function number(value) { return Math.round(Number(value) * 1000) / 1000; }
  function takeReturnFragment() {
    var hash = global.location && global.location.hash || '', parts = hash.replace(/^#/, '').split('&');
    var owned = parts.filter(function (part) { return /^ema_(mural|visualization)$/.test(part.split('=')[0]); });
    if (!owned.length) return null;
    // Consume only our field. Query strings and unrelated fragment bytes remain intact.
    var rest = parts.filter(function (part) { return !/^ema_(mural|visualization)$/.test(part.split('=')[0]); }).join('&');
    try {
      if (!global.history || !global.history.replaceState) throw new Error('history_unavailable');
      global.history.replaceState(global.history.state, '', global.location.pathname + (global.location.search || '') + (rest ? '#' + rest : ''));
    } catch (_) { return { error: true, kind: owned[0] && owned[0].split('=')[0] }; }
    try {
      if (owned.length !== 1 || owned[0].length > 2048 || owned[0].indexOf('=') < 0) throw new Error('invalid_return');
      var text = decodeURIComponent(owned[0].slice(owned[0].indexOf('=') + 1));
      if (text.length > 2048) throw new Error('invalid_return');
      return { value: JSON.parse(text), kind: owned[0].split('=')[0] };
    } catch (_) { return { error: true, kind: owned[0] && owned[0].split('=')[0] }; }
  }
  function exactKeys(value, keys) {
    return value && typeof value === 'object' && !Array.isArray(value) &&
      Object.keys(value).length === keys.length && Object.keys(value).every(function (key) { return keys.indexOf(key) >= 0; });
  }
  function validateReturn(value) {
    if (!exactKeys(value, ['v', 'product_id', 'variant_id', 'width_cm', 'height_cm', 'crop', 'mirror', 'artwork_key', 'artwork_version']) ||
        value.v !== 1 || typeof value.product_id !== 'string' || !/^\d{1,20}$/.test(value.product_id) ||
        value.product_id !== String(adapter.productId) || typeof value.variant_id !== 'string' || !/^\d{1,20}$/.test(value.variant_id) ||
        typeof value.mirror !== 'boolean' || typeof value.artwork_key !== 'string' || value.artwork_key.length > 768 ||
        typeof value.artwork_version !== 'string' || !/^[A-Za-z0-9._-]{0,80}$/.test(value.artwork_version) ||
        !exactKeys(value.crop, ['x', 'y', 'width', 'height'])) throw new Error('invalid_return');
    function finite(value) { return typeof value === 'number' && Number.isFinite(value); }
    if (!finite(value.width_cm) || value.width_cm < 100 || value.width_cm > 3000 ||
        !finite(value.height_cm) || value.height_cm < 100 || value.height_cm > 800 ||
        Object.keys(value.crop).some(function (key) { return !finite(value.crop[key]) || value.crop[key] < 0 || value.crop[key] > 100000; }) ||
        value.crop.width <= 0 || value.crop.height <= 0 ||
        Math.abs(value.crop.width / value.crop.height / (value.width_cm / value.height_cm) - 1) > 0.001)
      throw new Error('invalid_return');
    return value;
  }
  function samePhysical(a, b) {
    return ['product_id', 'variant_id', 'width_cm', 'height_cm', 'mirror', 'artwork_url'].every(function (key) { return a[key] === b[key]; }) &&
      ['x', 'y', 'width', 'height'].every(function (key) { return Math.abs(a.crop[key] - b.crop[key]) <= 0.01; });
  }
  function applyPreviewReturn(incoming) {
    try {
      if (pendingCart || generationLocked) throw new Error('preview_busy');
      var data = incoming.value, source = adapter.previewSource(), url = new URL(source.artwork_url);
      if (!exactKeys(data, ['v', 'product_id', 'width_cm', 'height_cm', 'crop', 'mirror', 'artwork_key', 'artwork_version', 'visualization_mode']) ||
          data.v !== 1 || data.visualization_mode !== 'selected_crop' || data.product_id !== String(adapter.productId) ||
          typeof data.width_cm !== 'number' || typeof data.height_cm !== 'number' || typeof data.mirror !== 'boolean' ||
          !exactKeys(data.crop, ['x', 'y', 'width', 'height']) ||
          Object.keys(data.crop).some(function (key) { return typeof data.crop[key] !== 'number' || !Number.isFinite(data.crop[key]); }) ||
          url.protocol !== 'https:' || url.username || url.password || Array.from(url.searchParams.keys()).some(function (key) { return key !== 'v'; }) ||
          url.searchParams.getAll('v').length > 1 || url.hostname + url.pathname !== data.artwork_key || (url.searchParams.get('v') || '') !== data.artwork_version ||
          !Number.isFinite(source.source_width) || !Number.isFinite(source.source_height) ||
          data.crop.x + data.crop.width > source.source_width + .01 || data.crop.y + data.crop.height > source.source_height + .01)
        throw new Error('invalid_return');
      // A public framing handoff carries no access to any saved private photo.
      var prior = active && active.visualization;
      if (!active) active = { project_id: uuid(), version: 1 };
      active.visualization = {};
      try { previewSnapshot(data); } catch (error) { active.visualization = prior; throw error; }
      persist(); previewReturned = true;
      emit('mural_project_returned', Object.assign({}, currentPreviewConfiguration(), { stage: 'preview_refinement' })); return true;
    } catch (_) { previewReturned = true; previewReturnInvalid = true; return false; }
  }
  function applyReturn() {
    if (!pendingReturn || !adapter) return false;
    var incoming = pendingReturn; pendingReturn = null;
    if (incoming.kind === 'ema_visualization') return applyPreviewReturn(incoming);
    var priorActive = active, priorConfig, applied = false;
    try {
      if (incoming.error || pendingCart || generationLocked || !adapter.resolveReturn) throw new Error('invalid_return');
      var candidate = normalize(adapter.resolveReturn(validateReturn(incoming.value)));
      priorConfig = adapter.read();
      // A public configuration handoff never inherits private project access,
      // even when this browser happens to hold an identical configuration.
      active = { project_id: uuid(), version: 1 };
      var fingerprint = JSON.stringify(candidate);
      candidate.configuration_id = active.fingerprint === fingerprint && active.configuration ? active.configuration.configuration_id : uuid();
      active.configuration = candidate; active.fingerprint = fingerprint;
      applied = true; adapter.apply(candidate);
      var actual = normalize(adapter.read());
      if (!samePhysical(actual, candidate)) throw new Error('return_crop_changed');
      actual.configuration_id = candidate.configuration_id;
      active.configuration = actual;
      var withoutId = Object.assign({}, actual); delete withoutId.configuration_id;
      active.fingerprint = JSON.stringify(withoutId); active.updated_at = new Date().toISOString();
      cropCache = null; persist(); savedProject = JSON.parse(JSON.stringify(active));
      adapter.refreshQuote();
      if (adapter.returnStatus) adapter.returnStatus(T('Your saved dimensions, crop and paper are restored. The price below uses today’s store price.'), false);
      emit('mural_project_returned', { stage: 'configuration' }); return true;
    } catch (_) {
      if (applied && priorConfig) { try { adapter.apply(priorConfig); } catch (_) {} }
      active = priorActive;
      if (adapter.returnStatus) adapter.returnStatus(T('We could not restore this saved configuration. Please check the wall size, crop and paper before ordering.'), true);
      return false;
    }
  }
  function normalize(raw) {
    var width = raw && number(raw.width_cm), height = raw && number(raw.height_cm);
    if (!raw || !Number.isFinite(Number(raw.width_cm)) || !Number.isFinite(Number(raw.height_cm)) ||
      width < 100 || width > 3000 || height < 100 || height > 800)
      throw new Error('invalid_dimensions');
    if (!/^\d+$/.test(String(raw.product_id)) || !/^\d+$/.test(String(raw.variant_id))) throw new Error('invalid_variant');
    if (!raw.crop || ['x', 'y', 'width', 'height'].some(function (k) { return !Number.isFinite(Number(raw.crop[k])); }) ||
      raw.crop.width <= 0 || raw.crop.height <= 0) throw new Error('crop_not_ready');
    if (!Number.isFinite(Number(raw.unit_price)) || Number(raw.unit_price) < 0) throw new Error('invalid_price');
    // Use the same full-precision dimensions for the quote, cart and persisted configuration.
    var quantity = Math.ceil(width * height / 10000 - 1e-10);
    return { product_id: String(raw.product_id), product_handle: raw.product_handle || '',
      variant_id: String(raw.variant_id), paper_name: String(raw.paper_name || ''),
      width_cm: width, height_cm: height, crop: { x: Math.max(0, number(raw.crop.x)), y: Math.max(0, number(raw.crop.y)),
        width: number(raw.crop.width), height: number(raw.crop.height) }, mirror: !!raw.mirror,
      artwork_url: String(raw.artwork_url || ''), currency: String(raw.currency || ''),
      unit_price: Number(raw.unit_price), billable_area_m2: quantity,
      quote_value: Math.round(Number(raw.unit_price) * quantity * 100) / 100 };
  }
  function key() { return 'ema_mural_project_v1_' + adapter.productId; }
  function persist() { try { localStorage.setItem(key(), JSON.stringify(active)); } catch (_) {} }
  function snapshot() {
    if (!adapter) throw new Error('configuration_unavailable');
    var config = normalize(adapter.read());
    var fingerprint = JSON.stringify(config);
    if (!active) active = { project_id: uuid(), version: 1 };
    if (!active.configuration || active.fingerprint !== fingerprint) {
      config.configuration_id = uuid();
      active.configuration = config; active.fingerprint = fingerprint;
      active.updated_at = new Date().toISOString(); cropCache = null;
    }
    return JSON.parse(JSON.stringify(active.configuration));
  }
  function previewSnapshot(options) {
    if (!adapter || !adapter.previewSource) throw new Error('configuration_unavailable');
    var source = adapter.previewSource(), config = { configuration_type: 'visualization', visualization_mode: 'full_artwork',
      product_id: String(source.product_id), product_handle: source.product_handle || '', artwork_url: String(source.artwork_url || '') };
    if (!/^\d+$/.test(config.product_id) || !/^https:\/\//.test(config.artwork_url)) throw new Error('configuration_unavailable');
    if (options && options.visualization_mode === 'selected_crop') {
      var width = number(options.width_cm), height = number(options.height_cm), crop = options.crop;
      if (!Number.isFinite(width) || !Number.isFinite(height) || width < 100 || width > 3000 || height < 100 || height > 800 ||
          !crop || ['x', 'y', 'width', 'height'].some(function (key) { return !Number.isFinite(Number(crop[key])) || number(crop[key]) < 0; }) ||
          crop.width <= 0 || crop.height <= 0 || Math.abs(crop.width / crop.height / (width / height) - 1) > .001)
        throw new Error('invalid_dimensions');
      config.visualization_mode = 'selected_crop'; config.width_cm = width; config.height_cm = height;
      config.crop = { x: number(crop.x), y: number(crop.y), width: number(crop.width), height: number(crop.height) }; config.mirror = options.mirror === true;
    }
    if (!active) active = { project_id: uuid(), version: 1 };
    var holder = active.visualization || (active.visualization = {}), fingerprint = JSON.stringify(config);
    if (!holder.configuration || holder.fingerprint !== fingerprint) {
      config.configuration_id = uuid(); holder.configuration = config; holder.fingerprint = fingerprint;
      active.updated_at = new Date().toISOString(); persist();
    }
    return JSON.parse(JSON.stringify(holder.configuration));
  }
  function currentPreviewConfiguration() {
    return active && active.visualization && active.visualization.configuration ? JSON.parse(JSON.stringify(active.visualization.configuration)) : null;
  }
  function previewHolder() { return active && active.visualization || active; }
  function configurationChanged(stage) {
    try {
      var config = snapshot();
      persist();
      emit('mural_configuration_started', { stage: stage }, 'started:' + active.project_id);
      if (stage === 'paper') emit('mural_paper_selected', {}, 'paper:' + config.configuration_id);
      if (stage === 'crop' || stage === 'mirror') emit('mural_crop_confirmed', { stage: stage }, 'crop:' + config.configuration_id);
    } catch (_) { emit('mural_configuration_invalid', { stage: stage, error_code: 'invalid_configuration' }); }
  }
  function money(value, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(value); }
    catch (_) { return Number(value).toFixed(2) + ' ' + currency; }
  }
  function dimensionText(value) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 3 }).format(value); }
    catch (_) { return String(value); }
  }
  function quote() {
    try {
      var c = snapshot();
      // Translate the visible label only: saved paper identity/fingerprint stays canonical.
      return T('{width} × {height} cm · {paper} · {price}', { width: dimensionText(c.width_cm),
        height: dimensionText(c.height_cm), paper: T(c.paper_name), price: money(c.quote_value, c.currency) });
    } catch (_) { return T('Enter your wall dimensions and choose your crop first.'); }
  }
  async function cropFor(configuration) {
    if (cropCache && cropCache.id === configuration.configuration_id) return cropCache.url;
    var response = await fetch(adapter.cropApi, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ origin_url: configuration.artwork_url, product_id: Number(configuration.product_id),
        mirror_mode: configuration.mirror, crop_x: configuration.crop.x, crop_y: configuration.crop.y,
        crop_width: configuration.crop.width, crop_height: configuration.crop.height }) });
    var body = await response.json();
    if (!response.ok || body.status !== 'success' || !/^https:\/\//.test(body.image_url || '')) throw new Error('crop_failed');
    cropCache = { id: configuration.configuration_id, url: body.image_url };
    return body.image_url;
  }
  function lockGeneration(value) { generationLocked = !!value; if (adapter && adapter.setLocked) adapter.setLocked(generationLocked || pendingCart); }
  async function ensureRemoteProject(apiBase, config, designUrl) {
    var permissions = consent();
    var metadata = Object.assign({}, config, {
      configuration_version: 1, locale: document.documentElement.lang || 'en',
      analytics_consent: permissions.analytics, ad_personalization_consent: permissions.marketing,
      event_uuid: uuid() });
    if (config.configuration_type !== 'visualization' && designUrl) metadata.design_crop_url = designUrl;
    var holder = config.configuration_type === 'visualization' ? active.visualization : active;
    var remote = holder.remote, url = apiBase + '/projects', headers = { 'Content-Type': 'application/json' };
    if (remote && remote.api_base === apiBase && Number(remote.expires_at) * 1000 <= Date.now()) {
      // Replacement belongs to the outer flow: a proof already obtained for
      // this project must never be carried into a silently created replacement.
      var expired = new Error('project_expiring'); expired.code = 'project_expiring'; expired.status = 409;
      expired.remote_project_id = remote.project_id; throw expired;
    }
    var body = metadata;
    if (remote && remote.api_base === apiBase) {
      url += '/' + encodeURIComponent(remote.project_id);
      headers.Authorization = 'Bearer ' + remote.project_token;
      body = { expected_version: remote.version, metadata: metadata };
    }
    var response = await fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) });
    var data = await response.json();
    if (!response.ok || !data.project_id) {
      var error = new Error(data.message || T('Could not save the project.')); error.code = data.code; error.status = response.status;
      // Explicit null distinguishes a failed creation from a rejected update.
      error.remote_project_id = remote && remote.api_base === apiBase ? remote.project_id : null;
      throw error;
    }
    if (!data.project_token && remote) data.project_token = remote.project_token;
    if (!data.project_token) throw new Error('project_token_missing');
    // Functional credentials never enter an analytics payload or a storefront URL.
    holder.remote = { project_id: data.project_id, project_token: data.project_token, project_url: data.project_url,
      version: data.version, expires_at: data.expires_at, api_base: apiBase, previous_job_id: data.job_id || '',
      configuration_id: config.configuration_id, identity_key: remote && remote.project_id === data.project_id ? remote.identity_key : undefined };
    // Keep the browser journey ID stable across service creation/renewal. The
    // unchanged configuration_id explicitly joins this remote snapshot to the
    // analytics journey without putting service credentials in the dataLayer.
    persist(); return holder.remote;
  }
  function bindRemoteIdentity(projectId, key) {
    var holder = previewHolder();
    if (!holder || !holder.remote || holder.remote.project_id !== projectId || !/^[a-f0-9]{64}$/.test(key)) return false;
    holder.remote.identity_key = key; persist(); return true;
  }
  function resetRemoteProject(expectedProjectId) {
    var holder = previewHolder();
    if (!holder || !holder.remote || holder.remote.project_id !== expectedProjectId) return false;
    if (savedProject) {
      [savedProject, savedProject.visualization].forEach(function (saved) {
        if (saved && saved.remote && saved.remote.project_id === expectedProjectId) { delete saved.remote; delete saved.preview; }
      });
    }
    delete holder.remote; delete holder.preview; persist(); return true;
  }
  async function addToCart() {
    if (pendingCart || generationLocked || !adapter) return;
    var button = document.getElementById('cropperBtn'), error = document.getElementById('add_to_cart_error_box');
    pendingCart = true; var prior = button.innerHTML; button.disabled = true;
    if (adapter.setLocked) adapter.setLocked(true);
    try {
      var config = snapshot(), lifecycleId = active.project_id, remote = previewHolder().remote, projectId = remote && remote.project_id;
      persist();
      if (error) { error.textContent = ''; error.style.display = 'none'; }
      emit('mural_configured', { stage: 'cart' }, 'configured:' + config.configuration_id);
      button.textContent = adapter.processingText || T('Preparing your mural…');
      var image = await cropFor(config);
      // Capture one immutable snapshot before asynchronous work: edits cannot mismatch quote/crop/variant.
      var props = { Height: config.height_cm + ' cm', Width: config.width_cm + ' cm', imageURL: image,
        _ema_lifecycle_id: lifecycleId, _ema_configuration_id: config.configuration_id,
        _ema_mural: 'true', _ema_billable_area_m2: String(config.billable_area_m2) };
      if (projectId) props._ema_project_id = projectId;
      if (active.preview && active.preview.configuration_id === config.configuration_id) props._ema_preview_job_id = active.preview.job_id || '';
      await adapter.addItem(config.variant_id, config.billable_area_m2, props);
      global.location.href = (global.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
    } catch (err) {
      if (error) { error.style.display = 'block'; error.textContent = err.message === 'invalid_dimensions' ?
        T('Enter a width from {min_width} to {max_width} cm and height from {min_height} to {max_height} cm.', { min_width: dimensionText(100), max_width: dimensionText(3000), min_height: dimensionText(100), max_height: dimensionText(800) }) : T('We could not add this configuration. Please check your size and try again.'); }
      emit('mural_cart_failed', { stage: 'cart', error_code: err.message === 'invalid_dimensions' ? 'invalid_dimensions' : 'cart_failed' });
    } finally { pendingCart = false; button.disabled = false; button.innerHTML = prior; if (adapter.setLocked) adapter.setLocked(generationLocked); adapter.refreshQuote(); }
  }
  function register(options) {
    adapter = options;
    try {
      var saved = JSON.parse(localStorage.getItem(key()) || 'null');
      if (saved && saved.version === 1 && ((saved.configuration && saved.configuration.product_id === String(options.productId)) || (saved.visualization && saved.visualization.configuration && saved.visualization.configuration.product_id === String(options.productId)))) {
        savedProject = JSON.parse(JSON.stringify(saved)); active = saved;
      }
    } catch (_) {}
    applyReturn();
    document.dispatchEvent(new CustomEvent('ema:mural-ready'));
  }
  function savePreview(data) {
    if (!active) return;
    var holder = previewHolder();
    holder.preview = { job_id: data.job_id || '', url: data.preview_url || '', project_url: data.project_url || '',
      configuration_id: data.configuration_id || holder.configuration.configuration_id, created_at: new Date().toISOString() };
    persist();
  }
  function restoreSaved() {
    if (!adapter || !savedProject || !savedProject.configuration) return false;
    var restoring = JSON.parse(JSON.stringify(savedProject));
    adapter.apply(restoring.configuration); active = restoring; cropCache = null; persist();
    emit('mural_project_returned', { stage: 'configuration' }); return true;
  }
  function preview() {
    var holder = previewHolder();
    return holder && holder.preview && holder.configuration && holder.preview.configuration_id === holder.configuration.configuration_id ? holder.preview : null;
  }
  global.EMAMuralLifecycle = { version: VERSION, register: register, snapshot: snapshot, quote: quote, previewSnapshot: previewSnapshot, currentPreviewConfiguration: currentPreviewConfiguration,
    takePreviewReturn: function () { var value = previewReturned; previewReturned = false; return value; },
    previewReturnInvalid: function () { return previewReturnInvalid; },
    ready: function () { return !!adapter; },
    moveEditor: function (host) { if (adapter && adapter.moveEditor) adapter.moveEditor(host); },
    remote: function () { var holder = previewHolder(); return holder && holder.remote ? Object.assign({}, holder.remote) : null; },
    configurationChanged: configurationChanged, emit: emit, consent: consent, cropFor: cropFor,
    addToCart: addToCart, lockGeneration: lockGeneration, savePreview: savePreview, ensureRemoteProject: ensureRemoteProject,
    resetRemoteProject: resetRemoteProject, bindRemoteIdentity: bindRemoteIdentity,
    hasSaved: function () { return !!savedProject; },
    restoreSaved: restoreSaved, preview: preview, projectId: function () { if (!active) active = { project_id: uuid(), version: 1 }; return active.project_id; },
    thumbnail: function () { return adapter && adapter.thumbnail(); }, uuid: uuid };
  if (global.addEventListener) global.addEventListener('hashchange', function () {
    var next = takeReturnFragment(); if (next) { pendingReturn = next; applyReturn(); }
  });
  if (typeof module === 'object' && module.exports) module.exports = { normalize: normalize, consent: consent, emit: emit };
})(typeof window === 'undefined' ? globalThis : window);
